import React from "react";

export const TextError = (props) => {
  return (
    <div className="error" style={{ color: "red" }}>
      <span>{props.children}</span>
    </div>
  );
};
